import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchfieldStockById,
  fetchfieldStocks,
  updatefieldStock,
} from "./thunk";

interface fieldStockState {
  fieldStockList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedfieldStock: any;
}

const initialState: fieldStockState = {
  fieldStockList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedfieldStock: null,
};

const fieldStockSlice = createSlice({
  name: "fieldStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchfieldStocks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchfieldStocks.fulfilled, (state, action) => {
        state.loading = false;
        state.fieldStockList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchfieldStocks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch fieldStocks";
      })
      .addCase(fetchfieldStockById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchfieldStockById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedfieldStock = action.payload;
      })
      .addCase(fetchfieldStockById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updatefieldStock.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.fieldStockList = state.fieldStockList.map((dist) =>
          dist.id === action.payload.id ? action.payload : dist
        );
      })
      .addCase(updatefieldStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update fieldStocks";
      });
  },
});

export default fieldStockSlice.reducer;
